import styled from 'styled-components';
import { Checkbox } from '@insly/qmt-reactjs-ui-lib';
import {
  AGREEMENT_PARAMETER_TYPE_POINT,
  AGREEMENT_PARAMETER_TYPE_SUBHEADER,
  AGREEMENT_PARAMETER_TYPE_TEXT,
} from './consts';

const FONT_WEIGHT_AGREEMENT_PARAMETER_TYPES = [AGREEMENT_PARAMETER_TYPE_POINT, AGREEMENT_PARAMETER_TYPE_TEXT];
const COLOR_AGREEMENT_PARAMETER_TYPES = [AGREEMENT_PARAMETER_TYPE_POINT, AGREEMENT_PARAMETER_TYPE_TEXT];

export const AgreementCheckbox = styled(Checkbox)<{ parameterType?: string }>`
  align-items: flex-start;
  flex: 1;
  .qmt-ui-checkbox-label {
    font-size: 13px;
  }
  .qmt-ui-checkbox-label {
    padding-top: 4px;
  }
  margin-left: ${({ parameterType }) => parameterType === AGREEMENT_PARAMETER_TYPE_POINT && '20px'};
`;

export const AgreementTitle = styled.h3<{ parameterType: string }>`
  line-height: normal;
  align-self: center;
  font-family: ${({ theme }) => theme.font.light };
  font-weight: ${({ parameterType }) => FONT_WEIGHT_AGREEMENT_PARAMETER_TYPES.includes(parameterType) && 'normal' };
  color: ${({ parameterType }) => COLOR_AGREEMENT_PARAMETER_TYPES.includes(parameterType) && 'rgb(119, 119, 119)'};
  font-size: ${({ parameterType }) => {
    switch (parameterType) {
      case AGREEMENT_PARAMETER_TYPE_TEXT:
      case AGREEMENT_PARAMETER_TYPE_POINT:
        return '14px';
      case AGREEMENT_PARAMETER_TYPE_SUBHEADER:
        return '16px';
      default:
        return '18px';
    }
  }};
`;

export const Statement = styled.div`
  position: relative;
  gap: 10px;
  display: flex;
`;
